module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-01-e5cceb7115a52aadabffebd713d1926f.jpg";